module.exports = __webpack_public_path__ + "img/newspapers_button_next_down.42318f30.png";